<div>
  <div class="d-flex justify-content-between mt-4">
    <div>
      <searcher
        [label]="'Buscar Objeto Auditable'"
        (onChange)="search($event)"
        [showLoading]="showLoading"
      ></searcher>
    </div>
    <div>
      <button (click)="create()" class="create-button" *ngIf="canCreate">
        Crear Objeto Auditable
      </button>
    </div>
  </div>
  <app-table
    [data]="auditableObjectList"
    [displayedColumns]="columns"
    [columnsNames]="columnsNames"
    [total]="total"
    [offset]="offset"
    [limit]="limit"
    (update)="update($event)"
    (delete)="delete($event)"
    (onPageChange)="handlePageChange($event)"
  ></app-table>
</div>
